import { combineReducers } from 'redux';

import userprofile from './userprofile/reducer';

export default combineReducers({
  userprofile,
});



// WEBPACK FOOTER //
// ./src/pages/userprofile/state/reducer.js